import { useState, useEffect } from 'react';
import { Channel, Socket } from 'phoenix';
import { BASE_API_URL } from '@/config/environment';

interface Props {
  room: string;
  events: string[];
  token?: string;
  onNewMessage(payload: any): void;
}

function useWebsockets({ room, events, token, onNewMessage }: Props) {
  const [channel, setChannel] = useState<Channel>();
  const [connected, setConnected] = useState<boolean>(false);

  useEffect(() => {
    if (token) {
      const socket = new Socket(`${BASE_API_URL}/socket`, { params: { token } });

      socket.connect();
      const channel = socket.channel(room);

      setChannel(channel);

      channel
        .join()
        .receive('ok', () => {
          console.log('channel joined');
          setConnected(true);
        })
        .receive('error', () => {
          console.log('channel error');
          setConnected(false);
        });

      console.log('channel', channel);

      events.forEach((event) => channel.on(event, onNewMessage));

      return () => {
        setConnected(false);
        socket.disconnect();
      };
    }

    return () => {};
  }, []);

  useEffect(() => {
    events.forEach((event) => channel?.off(event));
    events.forEach((event) => channel?.on(event, onNewMessage));
  }, [onNewMessage]);

  return { connected, channel };
}

export default useWebsockets;
